module.exports = __webpack_public_path__ + "static/media/specialtyPopulation.685d07af.svg";